import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacings.md};
  color: ${({ theme }) => theme.colors.white};
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.xs} 10%`};
  background: ${({ theme }) => theme.colors.primary};

  & img {
    max-width: 200px;
  }

  li {
    padding-top: ${({ theme }) => theme.spacings.xxs};
    font-size: 1.1em;
  }

  @media screen and (max-width: 700px) {
    font-size: 0.9em;
    flex-direction: column;

    img {
      width: 100%;
    }
  }
`

export const Bottom = styled.div`
  width: 100%;
  font-size: 0.9em;
  display: flex;
  justify-content: space-around;
  padding: ${({ theme }) => `${theme.spacings.xs} 20%`};
  background: ${({ theme }) => theme.colors.black};

  @media screen and (max-width: 700px) {
    font-size: 0.7em;
    text-align: center;
    flex-direction: column;
  }
`

export const Spaced = styled.div`
  display: flex;
  justify-content: space-between;

  & div {
    width: 25;
  }
`
